export default __webpack_public_path__ + "static/media/81-min.11dcf77b.jpg";